"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeBase64 = encodeBase64;
exports.decodeBase64 = decodeBase64;
exports.cleanBase64 = cleanBase64;
exports.getBase64SourceSize = getBase64SourceSize;
// todo why not https://gist.github.com/jonleighton/958841 ?
// is there's something wrong with btoa?
var errors_1 = require("../common/errors");
function encodeBase64(arrayBuffer) {
    return btoa(String.fromCharCode.apply(null, new Uint8Array(arrayBuffer)));
}
function decodeBase64(base64) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
}
function cleanBase64(base64) {
    if (base64.match(/\s/))
        return base64.replace(/\s/g, "");
    return base64;
}
function getBase64SourceSize(base64) {
    if (base64 === undefined)
        return 0;
    base64 = cleanBase64(base64);
    if (base64 === "")
        return 0;
    if (base64.length < 4)
        throw new errors_1.CommonError("getBase64SourceSize: Invalid base64", null, "corrupted-base64", { base64: base64 });
    var lastBits = base64.length % 4;
    var lastBitsStr = base64.substr(base64.length - lastBits);
    var len = ((base64.length - lastBits) * 3) / 4;
    if (lastBits) {
        if (lastBits == 1)
            throw new errors_1.CommonError("getBase64SourceSize: Invalid base64", null, "corrupted-base64", { base64: base64 });
        if (lastBits == 2)
            lastBitsStr += "==";
        if (lastBits == 3)
            lastBitsStr += "=";
        if (lastBitsStr[2] == "=")
            len += 1;
        else if (lastBitsStr[3] == "=")
            len += 2;
    }
    else {
        if (base64[base64.length - 1] == "=")
            len--;
        if (base64[base64.length - 2] == "=")
            len--;
        return len;
    }
    return len;
}
